/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery',
	'../common/NonVIPREventTarget'
], function($, NonVIPREventTarget) {

	const BASE_SLOT_ID = 'actual';
	const TARGET_SLOT_ID = 'goal';

	class KpiEventTarget extends NonVIPREventTarget {
		constructor (...args) {
			super(...args);
			const options = args[0] || {};
			this.visControl = options.visControl;
			this.view = options.view;
			this.visualization = options.visualization;
			return this.getAPI();
		}

		/**
		 * Get the array of event targets based on the event.
		 * Event target represents a data point object that corresponds to the event.
		 *
		 * @param event	Event object
		 */
		getEventTargets (event) {
			const node = this._getTargetNode(event);

			if(!node || event.type === 'click') {
				return [];
			}

			var $node = $(node);
			//ignore the general widget
			if(!this.mouseWithinBoundCheck(event) || $node.hasClass('kpi-widget-content')) {
				return [];
			}
			return this._getTargets(event, $node);
		}

		remove () {
			this.visControl = null;
			this.view = null;
			super.remove();
		}

		_getTargets (event, $node) {
			var targets = [];
			let kpiNode$ = $($node.closest('.kpi-widget-value')[0]);

			// Possible the user clicked on the sparkline.  If so ignore it.
			if (!kpiNode$.length) {
				return targets;
			}

			const selectionContext = this._getTargetSelectionContext(kpiNode$);
			if (selectionContext) {
				targets.push({
					key: $node.parent().attr('class'),
					type: 'datapoint',
					selectionContext: selectionContext,
					slotAPIs: selectionContext.slots,
					source: $node,
					isEdgeSelect: true,
					values: this._getTargetValues(kpiNode$),
					area: 'visualization'
				});
			}

			return targets;
		}

		_getTargetSelectionContext($node) {
			let slot;
			const slots = this.visualization.getSlots();
			if ($node.hasClass('kpi-widget-base-value')) {
				slot = slots.getSlot(BASE_SLOT_ID);
			}else if ($node.hasClass('kpi-widget-target-value')) {
				slot = slots.getSlot(TARGET_SLOT_ID);
				//fix to disable event target for property set target value
				if (slot.getDataItemList().length === 0) {
					return null;
				}
			}
			return {
				mapIndex: 0,
				slots: [slot]
			};
		}

		_getTargetValues ($node) {
			let slots = [];
			let value;
			if ($node.hasClass('kpi-widget-base-value')) {
				value = this.view.getBaseValue();
			} else if ($node.hasClass('kpi-widget-target-value')) {
				value = this.view.getTargetValue();
			}
			if ($.isNumeric(value)) {
				slots.push([value]);
			}
			return slots;
		}
	}
	return KpiEventTarget;
});
